import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocationStrategy } from '@angular/common';
import { IBaseModel } from '../models/base.model';
import { IControle } from '../models/controle.model';

@Injectable({
  providedIn: 'root'
})
export class ControleService extends BaseService {


  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(criteriosAvaliacaoRiscosId: string, ativo: boolean, simplificado = false): Promise<IBaseModel<IControle[]>> {
    let params = new HttpParams();
    params = params.append('criteriosAvaliacaoRiscosId', criteriosAvaliacaoRiscosId || '0');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<IControle[]>>(`${this.apiBaseUrl}/controle`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<IControle>> {
    return this.httpClient
      .get<IBaseModel<IControle>>(`${this.apiBaseUrl}/controle/${id}`)
      .toPromise();
  }

  public async inserir(data: IControle): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/controle`, data)
      .toPromise();
  }

  public async atualizar(data: IControle): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/controle/${data.id}`, data)
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/controle/${id}/excluir`, {})
      .toPromise();
  }
}